import React from "react";
import { AuthContext } from "../../lib/AuthContext";
import ParentComponent from "../../lib/ParentComponent";
import firebase from "../../lib/firebase";
import { NavLink } from "react-router-dom";
import ar from "../../locale";
import Loading from "../../lib/Loading";
import { title, toolbarOptions } from "../../constants";
import PhotoUploader from "../../lib/PhotoUploader";
import UserTable from "../../lib/UserTable";

export default class AcademicsIndividual extends ParentComponent {
  static contextType = AuthContext;

  constructor(props, context) {
    super(props, context);
    this.state = {
      user: context.user,
      academic: {},
      loading: false,
    };
    this.academicRef = firebase
      .database()
      .ref("academics/" + this.props.match.params.key);
  }

  componentDidMount() {
    super.componentDidMount();
    document.title = title + " - " + ar.academic_talents;
    this.quill = new window.Quill("#quill-editor", {
      modules: {
        toolbar: toolbarOptions,
      },
      theme: "snow",
    });
    this.updateState();
    this.academicRef.on("value", (snapshot) => {
      if (!snapshot.exists()) {
        this.props.history.replace("/404");
      } else {
        this.state.academic = snapshot.val();
        this.quill.root.innerHTML = this.state.academic.content;
        this.updateState();
      }
    });
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    this.academicRef.off("value");
  }

  showLoading = (show) => {
    this.state.loading = show;
    this.updateState();
  };

  updateState = () => {
    this.setState((prev) => {
      return { ...prev };
    });
  };

  saveAvatar = async (croppedImage) => {
    this.showLoading(true);
    this.uploadAvatar(croppedImage);
  };

  uploadAvatar = (media) => {
    let { academic } = this.state;
    if (media) {
      firebase
        .storage()
        .ref("academics/" + academic.key)
        .put(media)
        .then((snapshot) => snapshot.ref.getDownloadURL())
        .then((downloadURL) => this.academicRef.update({ poster: downloadURL }))
        .then(() => {
          this.showLoading(false);
          this.showSuccess(ar.upload_successful);
        })
        .catch((error) => {
          this.showLoading(false);
          this.showError(error.message);
        });
    }
  };

  updateAcademicDetails = () => {
    let name = this.name.value;
    let content = this.quill.root.innerHTML;
    let contentText = null;
    if (content) {
      contentText = this.$(content).text(); //this is just for validation
    }
    if (name && contentText) {
      this.showLoading(true);
      this.academicRef
        .update({
          name: name,
          content: content,
        })
        .then(() => {
          this.showLoading(false);
          this.showSuccess(ar.operation_successful);
        })
        .catch((error) => {
          this.showLoading(false);
          this.showError(error.message);
        });
    } else {
      this.showError(ar.enter_valid_details);
    }
  };

  render() {
    let { academic, loading } = this.state;
    return (
      <div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card no-toolbar border-0">
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-9 mt-2">
                      <h2 className="card-title">{ar.academic_talents}</h2>
                      {academic && (
                        <h5 className="card-subtitle mb-0">{academic.title}</h5>
                      )}
                    </div>
                    <div className="col-sm-3 mt-2 text-md-left">
                      <NavLink
                        to="/academics/add"
                        className="btn btn-info btn-rounded"
                      >
                        {ar.add_new}
                      </NavLink>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              {academic && (
                <PhotoUploader
                  onSaveAvatar={this.saveAvatar}
                  avatar={academic.poster}
                  onlyaspectratio={true}
                  cropwidth={500}
                  cropheight={300}
                />
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="form-group">
                    <label
                      htmlFor="inputname"
                      className="control-label col-form-label font-weight-bold"
                    >
                      <span className="text-danger ml-1">*</span>
                      {ar.title}
                    </label>
                    <input
                      type="text"
                      ref={(e) => (this.name = e)}
                      className="form-control"
                      defaultValue={academic.title}
                      id="inputname"
                      placeholder={ar.title}
                    />
                  </div>
                  <div className="mt-5 mb-3 font-weight-bold">
                    <p>
                      <span className="text-danger ml-1">*</span>
                      {ar.enter_description}
                    </p>
                  </div>
                  <div id="quill-editor" className="min-h200"></div>
                  <div className="button-group mt-3">
                    <button
                      type="button"
                      className="btn waves-effect waves-light btn-rounded btn-info min-w100"
                      onClick={this.updateAcademicDetails}
                    >
                      {ar.save}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 mt-2">
              <h2 className="card-title">{ar.subscribers}</h2>
            </div>
            <div className="col-12 mt-2">
              <UserTable userids={academic.subscribedby || []} />
            </div>
          </div>
        </div>
        <Loading show={loading} />
      </div>
    );
  }
}
